import _ from 'underscore';

/**
 * Serialize the inlinechart preference object.
 * @param {object} attrs - { id, project, inlineChartData }
 * @returns {object} searialized data.
*/
export function serialize(attrs) {
  const { id, project, inlineChartData } = attrs;

  if (_.some(project, _.negate(_.isString))) {
    throw new Error('Invalid attributes');
  }

  return {
    Id: id,
    Name: `WebApp.${project}.InlineChart`,
    Data: inlineChartData,
    Type: 'object',
    Version: 1,
  };
}

/** de-serialize the inlinechart preference object.
 * @param {string} data - data from preference store
 * @return {object} de-seraialized inlinechart data.
*/
export function deserialize(data) {
  const match = data.Name.match(/^WebApp\.(\w+)\.InlineChart/);

  if (!match) {
    throw new Error('Invalid preference name');
  }

  const project = match.slice(1);
  const inlineChartData = data.Data;
  const id = data.Id;

  return { id, project, inlineChartData };
}
